import { getApiErrorMessage } from "./concurrency";

export function filenameFromContentDisposition(header) {
  const value = String(header || "");
  const encoded = /filename\*\s*=\s*UTF-8''([^;]+)/i.exec(value);
  if (encoded) {
    try {
      const name = decodeURIComponent(encoded[1].trim().replace(/^"|"$/g, ""));
      if (name && !/[\\/]/.test(name)) return name;
    } catch {
      // Use the plain filename when the encoded one is not valid.
    }
  }
  const quoted = /filename\s*=\s*"([^"]+)"/i.exec(value);
  const plain = quoted || /filename\s*=\s*([^;]+)/i.exec(value);
  if (!plain) return "";
  const name = plain[1].trim();
  if (!name || /[\\/]/.test(name)) return "";
  return name;
}

export function readBlobText(data) {
  if (typeof data?.text === "function") return data.text();
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(String(reader.result || ""));
    reader.onerror = () => reject(reader.error);
    reader.readAsText(data);
  });
}

export async function exportErrorMessage(error, fallback) {
  const data = error?.response?.data;
  if (typeof Blob !== "undefined" && data instanceof Blob) {
    try {
      const parsed = JSON.parse(await readBlobText(data));
      if (parsed?.error) return parsed.error;
      if (parsed?.detail) return parsed.detail;
    } catch {
      // A non-JSON body still uses the fallback.
    }
    return fallback;
  }
  return getApiErrorMessage(error, fallback);
}

export function downloadBlob(response, fallbackName, mimeType) {
  const blob = new Blob([response.data], { type: mimeType });
  const url = URL.createObjectURL(blob);
  try {
    const link = document.createElement("a");
    link.href = url;
    link.download =
      filenameFromContentDisposition(response.headers?.["content-disposition"]) || fallbackName;
    document.body.appendChild(link);
    link.click();
    link.remove();
  } finally {
    URL.revokeObjectURL(url);
  }
}
